module.exports = __webpack_public_path__ + "static/img/title.a461e57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/alpa_bern/title.jpg
// module id = 357
// module chunks = 1